export const dashboardDetailsStyles = {
  container: {
    width: "20%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    padding: 2,
  },
  logo: {
    height: "50px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid",
    paddingBottom: 3,
  },
  textRow: {
    mt: 2,
    justifyContent: "flex-start",
  },
};
